import { render, staticRenderFns } from "./ProductOrderDocumentsPopUp.vue?vue&type=template&id=3a4b007a&scoped=true&"
import script from "./ProductOrderDocumentsPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderDocumentsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderDocumentsPopUp.vue?vue&type=style&index=0&id=3a4b007a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b007a",
  null
  
)

export default component.exports